import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Constants from "../../utils/constants";
import { Container, Grid, Card, CardContent, CardMedia, CardActionArea, Typography } from "../../utils/ui";
import PageLoader from '../../components/loader';
import { DepartmentsUIWrapper } from './style';
import { getDepartments, setCurrentDepartment, getLoading } from "./departmentsSlice";
import { getTeams } from '../Configuration/configSlice';
import SettingsButton from '../../components/common/settingsButton';
import { getLocalData } from '../../services/storageManager';


const floatingButtonStyle = {
    position: 'absolute',
    top: 50,
    right: 70
}

export default function DepartmentList() {
    const { PAGE_HEADER, ASSETS } = Constants;
    const departmentList = useSelector(getDepartments);
    const isLoading = useSelector(getLoading);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const teamsList = getLocalData('teams');

    /**Select department-->navigate to Employee list */
    const handleDeptSelection = (dept) => (e) => {
        e.preventDefault();
        const selectedDeptId = dept.id;
        dispatch(setCurrentDepartment(dept));
        navigate(`${Constants.ROUTES.DEPARTMENT_LIST}/${selectedDeptId}${Constants.ROUTES.SHIFT_LIST}`);
    }

    return (
        <>
            {/* <Header shift={{}} showOnly={[]}/> */}
            {isLoading ? <PageLoader /> : ''}
            <Container sx={{ height: '100%' }}>
                <div style={floatingButtonStyle}><SettingsButton/></div>
                <DepartmentsUIWrapper>
                    <img src={ASSETS.APP_LOGO.PATH} alt={ASSETS.APP_LOGO.ALT_TEXT} className="logo" />
                    <div className='pageHeader'>{PAGE_HEADER.SELECT_DEPT}</div>
                    {/* <div className='deptListContainer'> */}

                    {/* </div> */}
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} justifyContent="center">
                        {departmentList.map((dept, index) => 
                        teamsList.includes(dept.teamId) ? <Grid item key={index}>
                            <Card sx={{ maxWidth: 345}}>
                                <CardActionArea onClick={handleDeptSelection(dept)} >
                                    {/* <CardMedia
                                        component="img"
                                        height="140"
                                        image="/static/images/cards/contemplative-reptile.jpg"
                                        alt="green iguana"
                                    /> */}
                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="div" alignContent='center'>
                                            {dept.name}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" alignContent='center'>
                                            {dept.team}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid> : null)}
                    </Grid>
                </DepartmentsUIWrapper>
            </Container>
        </>
    )
}